<template>
  <SelectInput
    class="mt-3"
    label="Default Billing Type"
    :items="billingTypes"
    v-model="settings.defaultBillingTypeId"
  />
</template>

<script>
import SelectInput from "./common/SelectInput.vue";

export default {
  components: { SelectInput },
  props: ["value"],
  data() {
    return {
      settings: {
        defaultBillingTypeId: null
      },
      billingTypes: [
        {
          id: 0,
          displayName: "Patient/Insurance"
        },
        {
          id: 1,
          displayName: "Doctor/Client"
        }
      ]
    };
  },
  mounted() {
    if (this.value) {
      this.settings = { ...this.settings, ...JSON.parse(this.value) };
    }
  },
  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(nv) {
        this.$emit("changeJSON", JSON.stringify(nv));
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
